const bases = require('bases')
const { isDev, isTest } = require('./env')

function buildLink (tenancyName, linkId) {
  const baseUrl = isDev ? 'http://localhost:3000/' : isTest ? 'https://test.go.knackly.io/' : 'https://go.knackly.io/'
  console.log(linkId)
  return `${baseUrl}${tenancyName}/links/${linkId}`
}
exports.buildLink = buildLink

function linkToId (linkStr) {
  const l = Math.ceil(linkStr.length / 2)
  return chunkTo16(linkStr.substring(0, l)) + chunkTo16(linkStr.substring(l))
}
exports.linkToId = linkToId

function idToLink (idStr) {
  const l = Math.ceil(idStr.length / 2)
  return chunkTo64(idStr.substring(0, l)) + chunkTo64(idStr.substring(l))
}
exports.idToLink = idToLink

const alpha64 = 'CgnVxID9OLa8XEom0BKf-FTWlUY5zjk3dbMJQ76pPA1r2ewi~yNRZucqHtGsSv4h'

function chunkTo64 (chunk16) {
  const l = Math.ceil(chunk16.length * 2 / 3)
  return bases.toAlphabet(parseInt(chunk16, 16), alpha64).padStart(l, alpha64[0])
}

function chunkTo16 (chunk64) {
  const l = Math.floor(chunk64.length * 3 / 2)
  return bases.toBase16(bases.fromAlphabet(chunk64, alpha64)).padStart(l, '0')
}
